import { isAxiosError } from 'axios';
import Env from '~/credsystem/env';
import apiSSOCredSystem from '~/credsystem/services/apiSSOCredSystem';
import { CredsystemLocalStorage } from '~/credsystem/storage/LocalStorage';
import { CREDSYSTEM_APP_UID } from '~/credsystem/storage/constants';
import { MarisaAppUtils } from '~/utils/MarisaAppUtils';

const CREDSYSTEM_CLIENT_SECRET = Env.CREDSYSTEM_CLIENT_SECRET;

interface GetCredSystemUserTokenParams {
  document: string;
  password: string;
}

interface APISuccessResponse {
  access_token: string;
  expires_in: number;
  refresh_token: string;
  refresh_expires_in: number;
  token_type: string;
}

interface APIErrorResponse {
  error: string;
  error_description: string & {
    httpStatusCode: number;
    message: string;
    data: {
      credmais_response: {
        sessaoId: string;
        atualizaApp: boolean;
        trocaDispositivo: boolean;
        access_token: string;
      };
    };
  };
}

interface CredmaisResponse {
  httpStatusCode?: number;
  data: {
    credmais_response: {
      sessaoId: string;
      atualizaApp: boolean;
      trocaDispositivo: boolean;
      access_token: string;
    };
  };
  code?: string;
  message?: string;
}

interface FuncResponse {
  code?: string;
  token?: string;
  refreshToken?: string;
  changeDevice?: boolean;
  validationToken?: string;
  message?: string;
}

type APIResponse = APISuccessResponse & APIErrorResponse;

export async function getCredSystemUserTokenUseCase({
  document,
  password,
}: GetCredSystemUserTokenParams): Promise<FuncResponse | null> {
  try {
    const deviceInfo = {
      app: 'APP_MARISA',
      dispositivo: {
        dispositivoId:
          MarisaAppUtils.origin === 'app'
            ? MarisaAppUtils.deviceId
            : await CredsystemLocalStorage.get(CREDSYSTEM_APP_UID),
        idSistemaOperacional: MarisaAppUtils.OSId,
        versaoSistemaOperacional: MarisaAppUtils.OSVersion,
        modelo: MarisaAppUtils.deviceModel,
        versaoApp: '99999999',
      },
    };

    // const deviceInfo = {
    //   app: 'APP_MARISA',
    //   dispositivo: {
    //     dispositivoId: '29',
    //     idSistemaOperacional: deviceInfoModule.getSystemName(),
    //     versaoSistemaOperacional: deviceInfoModule.getSystemVersion(),
    //     modelo: deviceInfoModule.getModel(),
    //   },
    // };

    const body = {
      client_id: 'appmarisa',
      client_secret: CREDSYSTEM_CLIENT_SECRET,
      username: document,
      password: password,
      grant_type: 'password',
      infosAdicionais: encodeURI(JSON.stringify(deviceInfo)),
    };

    const response = await apiSSOCredSystem.post<APIResponse>(
      `/auth/realms/marisa/protocol/openid-connect/token`,
      body
    );

    return {
      token: response?.data?.access_token,
      refreshToken: response?.data?.refresh_token,
    };
  } catch (error) {
    if (isAxiosError(error))
      if (error.response?.data.error_description.includes('{')) {
        const ErrorDescription = JSON.parse(
          error.response?.data.error_description
        ) as CredmaisResponse;

        if (!ErrorDescription.data?.credmais_response)
          return {
            code:
              ErrorDescription.httpStatusCode?.toString() ||
              ErrorDescription.code,
          };

        return {
          code: error.response?.status.toString(),
          changeDevice:
            ErrorDescription.data.credmais_response.trocaDispositivo,
          validationToken: ErrorDescription.data.credmais_response.access_token,
        };
      } else {
        return {
          code: error.response?.status.toString(),
          message: error.response?.data.error_description,
        };
      }

    return null;
  }
}

export async function getCredSystemUserRefreshedTokenUseCase(
  refreshToken: string
): Promise<FuncResponse | null> {
  try {
    const body = {
      client_id: 'appmarisa',
      client_secret: CREDSYSTEM_CLIENT_SECRET,
      grant_type: 'refresh_token',
      refresh_token: refreshToken,
    };

    const response = await apiSSOCredSystem.post<APISuccessResponse>(
      `/auth/realms/marisa/protocol/openid-connect/token`,
      body
    );

    return {
      token: response.data.access_token,
      refreshToken: response.data.refresh_token,
    };
  } catch (error) {
    return null;
  }
}
